import React from "react";

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-file-earmark-text"
      viewBox="0 0 16 16"
    >
      <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
      <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
    </svg>
  );
};

export const CheckBoxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="currentColor"
      className="bi bi-check2-square text-primary"
      viewBox="0 0 16 16"
    >
      <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
      <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
    </svg>
  );
};

export const UserIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-person-circle ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
      <path
        fill-rule="evenodd"
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
      />
    </svg>
  );
};

export const CartIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-cart ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
    </svg>
  );
};

export const EmailIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-envelope ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z" />
    </svg>
  );
};

export const ChatIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-chat-left-text ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
      <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
    </svg>
  );
};

export const CallIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-telephone ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
    </svg>
  );
};

export const BuildingIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512 512"
      height={height}
      viewBox="0 0 512 512"
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path d="m485.344 458.604h-7.501v-230.62c0-10.483-8.529-19.012-19.013-19.012h-136.09v-183.444c0-14.03-11.415-25.445-25.445-25.445h-237.692c-14.03 0-25.445 11.415-25.445 25.445v433.075h-7.501c-14.699.001-26.657 11.959-26.657 26.658 0 14.698 11.958 26.656 26.656 26.656h458.688c14.698 0 26.656-11.958 26.656-26.656 0-14.699-11.958-26.657-26.656-26.657zm-436.187-433.076c0-5.76 4.686-10.445 10.445-10.445h237.692c5.76 0 10.445 4.686 10.445 10.445v183.444h-64.021c-10.484 0-19.014 8.528-19.014 19.012v172.483c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-172.483c0-2.212 1.801-4.012 4.014-4.012h215.112c2.213 0 4.013 1.8 4.013 4.012v230.619h-223.138v-23.073c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v23.073h-175.548zm436.187 471.389h-458.688c-6.428 0-11.656-5.229-11.656-11.656s5.229-11.657 11.656-11.657h458.688c6.428 0 11.656 5.229 11.656 11.657s-5.229 11.656-11.656 11.656z" />
          <path d="m117.329 45.787h-30.771c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m193.835 45.787h-30.772c-8.194 0-14.861 6.667-14.861 14.862v30.771c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m239.567 106.283h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.772c0-8.195-6.667-14.862-14.862-14.862h-30.772c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.196 6.667 14.863 14.862 14.863zm.138-45.496h30.497v30.496h-30.497z" />
          <path d="m117.329 139.412h-30.771c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m193.835 139.412h-30.772c-8.194 0-14.861 6.667-14.861 14.862v30.771c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m239.567 199.908h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862h-30.772c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862zm.138-45.496h30.497v30.496h-30.497z" />
          <path d="m117.329 233.036h-30.771c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m193.835 233.036h-30.772c-8.194 0-14.861 6.667-14.861 14.862v30.771c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m117.329 326.661h-30.771c-8.195 0-14.862 6.667-14.862 14.861v30.772c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.772c0-8.194-6.667-14.861-14.862-14.861zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m193.835 326.661h-30.772c-8.194 0-14.861 6.667-14.861 14.861v30.772c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.772c0-8.194-6.667-14.861-14.862-14.861zm-.138 45.496h-30.496v-30.496h30.496z" />
          <path d="m270.159 302.88h29.141c7.067 0 12.816-5.749 12.816-12.815v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.141c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.066 5.749 12.815 12.816 12.815zm2.184-39.033h24.773v24.033h-24.773z" />
          <path d="m270.159 364.189h29.141c7.067 0 12.816-5.749 12.816-12.816v-28.4c0-7.067-5.749-12.816-12.816-12.816h-29.141c-7.067 0-12.816 5.749-12.816 12.816v28.4c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.033h24.773v24.033h-24.773z" />
          <path d="m270.159 425.499h29.141c7.067 0 12.816-5.749 12.816-12.816v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.141c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.034h24.773v24.034h-24.773z" />
          <path d="m336.703 302.88h29.142c7.067 0 12.816-5.749 12.816-12.815v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.066 5.749 12.815 12.816 12.815zm2.184-39.033h24.774v24.033h-24.774z" />
          <path d="m336.703 364.189h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.4c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.4c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.033h24.774v24.033h-24.774z" />
          <path d="m336.703 425.499h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.034h24.774v24.034h-24.774z" />
          <path d="m403.248 302.88h29.142c7.067 0 12.816-5.749 12.816-12.815v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.066 5.749 12.815 12.816 12.815zm2.184-39.033h24.774v24.033h-24.774z" />
          <path d="m403.248 364.189h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.4c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.4c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.033h24.774v24.033h-24.774z" />
          <path d="m403.248 425.499h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.034h24.774v24.034h-24.774z" />
          <path d="m409.222 173.787c5.141 3.754 12.053 3.756 17.195 0 12.97-9.473 44.086-35.442 52.868-71.912.97-4.027-1.509-8.078-5.536-9.048-4.028-.965-8.078 1.51-9.048 5.536-7.762 32.233-37.515 56.248-46.882 63.128-11.785-8.652-48.787-39.035-48.787-78.903 0-26.901 21.886-48.787 48.786-48.787 21.132 0 39.761 13.476 46.356 33.532 1.294 3.935 5.533 6.077 9.468 4.782 3.935-1.294 6.076-5.533 4.782-9.468-8.625-26.227-32.98-43.847-60.606-43.847-35.172 0-63.786 28.615-63.786 63.787 0 47.223 42.242 81.744 55.19 91.2z" />
          <path d="m417.818 47.112c-19.561 0-35.475 15.914-35.475 35.476s15.914 35.476 35.475 35.476c19.562 0 35.476-15.914 35.476-35.476s-15.914-35.476-35.476-35.476zm0 55.951c-11.29 0-20.475-9.186-20.475-20.476s9.185-20.476 20.475-20.476 20.476 9.186 20.476 20.476-9.186 20.476-20.476 20.476z" />
        </g>
      </g>
    </svg>
  );
};

export const VpsIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512 512"
      height={height}
      viewBox="0 0 512 512"
      width={width}
      fill="#f8f9fa"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m84.721 50.097h193.005c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-193.005c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z" />
      <path d="m84.721 82.552h193.005c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-193.005c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z" />
      <path d="m84.721 186.356h193.005c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-193.005c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z" />
      <path d="m84.721 218.811h193.005c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-193.005c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z" />
      <path d="m277.726 307.615h-193.005c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h193.005c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
      <path d="m277.726 340.07h-193.005c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h193.005c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
      <path d="m440.158 117.649c15.293 0 27.734-12.441 27.734-27.734v-62.18c.001-15.294-12.441-27.735-27.734-27.735h-368.316c-15.293 0-27.735 12.441-27.735 27.734v13.554c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-13.554c0-7.021 5.713-12.734 12.735-12.734h368.316c7.021 0 12.734 5.713 12.734 12.734v62.18c0 7.022-5.713 12.734-12.734 12.734h-368.316c-7.021 0-12.734-5.712-12.734-12.734v-13.553c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v13.554c0 15.293 12.441 27.734 27.734 27.734h5.379v18.166h-5.379c-15.293 0-27.734 12.441-27.734 27.734v62.18c0 15.293 12.441 27.734 27.734 27.734h5.379v18.166h-5.379c-15.293 0-27.734 12.441-27.734 27.734v62.18c0 15.293 12.441 27.734 27.734 27.734h160.844v37.023c-4.813 1.985-8.211 6.723-8.211 12.243v10.404h-20.896c-5.521 0-10.258 3.398-12.243 8.211h-134.703c-6.906 0-12.524 5.619-12.524 12.525v21.579c0 6.907 5.618 12.525 12.524 12.525h134.702c1.985 4.813 6.723 8.211 12.243 8.211h103.932c5.521 0 10.258-3.398 12.243-8.211h135.614c6.906 0 12.525-5.619 12.525-12.525v-21.579c0-6.906-5.619-12.525-12.525-12.525h-135.614c-1.985-4.813-6.723-8.211-12.243-8.211h-19.984v-10.404c0-5.521-3.398-10.258-8.211-12.243v-37.023h160.844c15.293 0 27.734-12.441 27.734-27.734v-13.553c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v13.554c0 7.021-5.713 12.734-12.734 12.734h-368.317c-7.021 0-12.734-5.713-12.734-12.734v-62.18c0-7.022 5.713-12.734 12.734-12.734h368.316c7.021 0 12.734 5.712 12.734 12.734v13.554c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-13.554c0-15.293-12.441-27.734-27.734-27.734h-2.718v-18.166h2.718c15.293 0 27.734-12.441 27.734-27.734v-62.18c0-15.293-12.441-27.734-27.734-27.734h-2.718v-18.166h2.718zm-381.05 354.511h131.228v16.629h-131.228zm393.785 16.629h-132.141v-16.629h132.141zm-147.141-24.841v33.052h-100.416v-33.052h26.639c4.143 0 7.5-3.358 7.5-7.5v-16.146h33.051v16.146c0 4.142 3.357 7.5 7.5 7.5zm-41.438-38.646h-16.629v-36.024h16.629zm158.126-153.673h-330.219v-18.166h330.22v18.166zm30.453-108.08v62.18c0 7.022-5.713 12.734-12.734 12.734h-368.317c-7.021 0-12.734-5.712-12.734-12.734v-62.18c0-7.021 5.713-12.734 12.734-12.734h368.316c7.022-.001 12.735 5.712 12.735 12.734zm-30.453-27.735h-330.219v-18.166h330.22v18.166z" />
      <path d="m429.77 58.824c0-16.828-13.69-30.518-30.518-30.518s-30.518 13.69-30.518 30.518 13.69 30.518 30.518 30.518 30.518-13.69 30.518-30.518zm-46.036 0c0-8.557 6.961-15.518 15.518-15.518s15.518 6.961 15.518 15.518-6.961 15.518-15.518 15.518-15.518-6.961-15.518-15.518z" />
      <path d="m399.252 225.139c16.827 0 30.518-13.69 30.518-30.518s-13.69-30.518-30.518-30.518-30.518 13.69-30.518 30.518 13.691 30.518 30.518 30.518zm0-46.035c8.557 0 15.518 6.961 15.518 15.518s-6.961 15.518-15.518 15.518-15.518-6.961-15.518-15.518 6.961-15.518 15.518-15.518z" />
      <path d="m368.734 330.454c0 16.828 13.69 30.518 30.518 30.518s30.518-13.69 30.518-30.518-13.69-30.518-30.518-30.518-30.518 13.69-30.518 30.518zm46.036 0c0 8.557-6.961 15.518-15.518 15.518s-15.518-6.961-15.518-15.518 6.961-15.518 15.518-15.518 15.518 6.961 15.518 15.518z" />
    </svg>
  );
};

export const WwwIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      height={height}
      viewBox="0 -27 512 511"
      width={width}
      className={className}
      fill="#f8f9fa"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m310.003906 168.5c-48.523437 0-88 39.476562-88 88s39.476563 88 88 88c48.523438 0 88-39.476562 88-88s-39.476562-88-88-88zm0 156c-37.496094 0-68-30.503906-68-68s30.503906-68 68-68 68 30.503906 68 68-30.503906 68-68 68zm0 0" />
      <path d="m310.003906 211.503906c-5.523437 0-10 4.476563-10 10 0 5.523438 4.476563 10 10 10 13.78125 0 24.996094 11.214844 24.996094 24.996094 0 5.523438 4.476562 10 10 10s10-4.476562 10-10c0-24.8125-20.183594-44.996094-44.996094-44.996094zm0 0" />
      <path d="m61.644531 75.902344c-2.539062-4.902344-8.570312-6.820313-13.476562-4.285156-4.90625 2.539062-6.824219 8.574218-4.285157 13.480468l26.917969 52c1.742188 3.367188 5.265625 5.425782 9.03125 5.402344 3.789063-.058594 7.222657-2.253906 8.863281-5.671875l16.296876-33.929687 17.699218 34.199218c1.722656 3.320313 5.148438 5.402344 8.882813 5.402344h.148437c3.792969-.058594 7.222656-2.253906 8.867188-5.671875l24.972656-52c2.390625-4.976563.292969-10.953125-4.683594-13.34375-4.980468-2.390625-10.953125-.292969-13.34375 4.6875l-16.296875 33.929687-17.703125-34.199218c-1.742187-3.367188-5.257812-5.433594-9.027344-5.402344-3.792968.058594-7.226562 2.253906-8.867187 5.671875l-16.292969 33.929687zm0 0" />
      <path d="m125.988281 20.5c2.632813 0 5.210938-1.070312 7.070313-2.929688 1.863281-1.859374 2.929687-4.441406 2.929687-7.070312s-1.066406-5.210938-2.929687-7.070312c-1.859375-1.859376-4.4375-2.929688-7.070313-2.929688-2.628906 0-5.207031 1.070312-7.066406 2.929688-1.863281 1.859374-2.933594 4.441406-2.933594 7.070312s1.070313 5.210938 2.933594 7.070312c1.859375 1.859376 4.4375 2.929688 7.066406 2.929688zm0 0" />
      <path d="m512 172.5v-132c0-22.054688-17.945312-40-40-40h-304.011719c-5.519531 0-10 4.476562-10 10s4.480469 10 10 10h304.011719c11.027344 0 20 8.972656 20 20v132c0 11.027344-8.972656 20-20 20h-48c-.289062 0-.570312.019531-.851562.042969-15.433594-27.195313-40.382813-48.304688-70.292969-58.777344l14.824219-30.863281 17.703124 34.195312c1.71875 3.324219 5.144532 5.402344 8.878907 5.402344h.152343c3.789063-.058594 7.222657-2.253906 8.863282-5.671875l24.972656-52c2.390625-4.976563.292969-10.949219-4.683594-13.339844-4.976562-2.394531-10.953125-.296875-13.34375 4.683594l-16.292968 33.929687-17.703126-34.199218c-1.742187-3.367188-5.253906-5.433594-9.03125-5.398438-3.792968.054688-7.222656 2.25-8.863281 5.667969l-16.296875 33.929687-17.699218-34.199218c-2.539063-4.902344-8.574219-6.820313-13.480469-4.28125-4.90625 2.539062-6.820313 8.570312-4.285157 13.476562l22.132813 42.753906c-6.105469-.882812-12.347656-1.351562-18.695313-1.351562-12.292968 0-24.195312 1.71875-35.476562 4.921875l22.378906-46.59375c2.390625-4.976563.292969-10.949219-4.6875-13.339844-4.976562-2.394531-10.953125-.296875-13.339844 4.683594l-16.296874 33.929687-17.703126-34.199218c-1.742187-3.367188-5.238281-5.433594-9.03125-5.398438-3.789062.054688-7.222656 2.25-8.863281 5.667969l-16.292969 33.929687-17.703124-34.199218c-2.539063-4.902344-8.570313-6.820313-13.476563-4.28125-4.90625 2.539062-6.824219 8.570312-4.285156 13.476562l26.917969 52c1.742187 3.367188 5.25 5.425782 9.03125 5.402344 3.789062-.058594 7.222656-2.253906 8.863281-5.671875l16.296875-33.925781 17.699218 34.195312c.296876.574219.660157 1.09375 1.054688 1.589844-24.523438 11.476562-44.898438 30.382812-58.207031 53.8125h-156.886719c-11.027344 0-20-8.972656-20-20v-132c0-11.027344 8.972656-20 20-20h40.992188c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10h-40.992188c-22.054688 0-40 17.945312-40 40v132c0 22.058594 17.945312 40 40 40h147.675781c-4.960937 13.75-7.671875 28.5625-7.671875 44 0 71.683594 58.316406 130 130 130 23.554688 0 45.667969-6.296875 64.742188-17.296875l79.367187 79.367187c6.609375 6.609376 15.292969 9.914063 23.976563 9.914063s17.367187-3.304687 23.976562-9.914063c13.222656-13.222656 13.222656-34.734374 0-47.957031l-31.183594-31.183593c-3.90625-3.902344-10.238281-3.90625-14.140624 0-3.90625 3.90625-3.90625 10.234374 0 14.140624l31.183593 31.1875c5.421875 5.421876 5.421875 14.246094 0 19.671876-5.421875 5.421874-14.246093 5.421874-19.667969 0l-76.738281-76.742188c29.546875-23.847656 48.484375-60.34375 48.484375-101.1875 0-15.4375-2.710937-30.25-7.671875-44h39.667969c22.058594 0 40-17.945312 40-40zm-201.996094 194c-60.652344 0-110-49.347656-110-110s49.347656-110 110-110 110 49.347656 110 110-49.34375 110-110 110zm0 0" />
      <path d="m433.019531 345.710938c-1.859375 1.859374-2.929687 4.4375-2.929687 7.070312 0 2.628906 1.070312 5.207031 2.929687 7.070312 1.871094 1.859376 4.441407 2.929688 7.070313 2.929688s5.210937-1.070312 7.070312-2.929688c1.871094-1.863281 2.929688-4.441406 2.929688-7.070312 0-2.632812-1.058594-5.210938-2.929688-7.070312-1.859375-1.859376-4.429687-2.929688-7.070312-2.929688-2.628906 0-5.210938 1.070312-7.070313 2.929688zm0 0" />
    </svg>
  );
};

export const CheckCircleIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-check-circle ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
    </svg>
  );
};

export const HostingIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512;"
      height={height}
      width={width}
      fill="#f8f9fa"
    >
      <g>
        <g>
          <path
            d="M512,165c0-5.987-1.161-11.808-3.45-17.301c-0.002-0.004-0.004-0.009-0.006-0.013L458.539,27.69
			C451.529,10.869,435.224,0,417.001,0H94.999C76.776,0,60.471,10.869,53.461,27.69L3.45,147.698C1.161,153.192,0,159.013,0,165v62
			c0,11.517,4.354,22.032,11.495,30C4.354,264.968,0,275.483,0,287v60c0,11.517,4.354,22.032,11.495,30
			C4.354,384.968,0,395.483,0,407v60c0,24.813,20.187,45,45,45h422c24.813,0,45-20.187,45-45v-60c0-11.517-4.354-22.032-11.495-30
			c7.142-7.968,11.495-18.483,11.495-30v-60c0-11.517-4.354-22.032-11.495-30c7.142-7.968,11.495-18.483,11.495-30V165z
			 M81.153,39.23C83.49,33.623,88.925,30,94.999,30h322.002c6.074,0,11.509,3.623,13.846,9.23l33.66,80.77H47.493L81.153,39.23z
			 M482,467c0,8.271-6.729,15-15,15H45c-8.271,0-15-6.729-15-15v-60c0-8.271,6.729-15,15-15h422c8.271,0,15,6.729,15,15V467z
			 M482,347c0,8.271-6.729,15-15,15H45c-8.271,0-15-6.729-15-15v-60c0-8.271,6.729-15,15-15h422c8.271,0,15,6.729,15,15V347z
			 M482,227c0,8.271-6.729,15-15,15H45c-8.271,0-15-6.729-15-15v-62c0-8.342,6.736-15,15-15h422c8.29,0,15,6.684,15,15V227z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M437,422H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h272c8.284,0,15-6.716,15-15S445.284,422,437,422z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M437,180H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h272c8.284,0,15-6.716,15-15S445.284,180,437,180z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M75,180c-8.284,0-15,6.716-15,15s6.716,17,15,17s15-8.716,15-17S83.284,180,75,180z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M437,302H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h272c8.284,0,15-6.716,15-15S445.284,302,437,302z" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="75" cy="317" r="15" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="75" cy="437" r="15" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
export const WhatsAppIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-whatsapp ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
    </svg>
  );
};

export const ChatLiveIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-chat ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z" />
    </svg>
  );
};

export const BlogIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-paperclip ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
    </svg>
  );
};

export const QuestionIcon = (props) => {
  const { width, height, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className={`bi bi-question-circle ${className}`}
      viewBox="0 0 16 16"
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
    </svg>
  );
};
